import api from '../callApi';

export const getRepStanceApi = (candidateIds, question) => {
    const request = {
        candidateIds,
        question
    };
    return api
        .post('Localization/GetRepresentativeAnswersOnQuestion', request)
        .then(response => response);
};

export const completeRepStanceApi = (apiRequestData, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime
    };

    return api
        .post('Widget/CompleteCheckRepPositionAsync', request, { useFingerprint: true })
        .then(response => response);
};
